/**
 * reasoningEffort.ts
 * 模型推理力度（模型速率）UI 常量：对应 OpenAI 兼容协议的 reasoning_effort 参数。
 * - DeepSeek V4：low / high（默认）/ max（medium 映射为 high）
 * - OpenRouter：透传给支持 reasoning_effort 的模型
 */

import type { AIReasoningEffort } from '@xiaotianshu/shared/ai';

/** UI 展示默认（DeepSeek V4 官方默认即为高） */
export const AI_DEFAULT_EFFORT: AIReasoningEffort = 'high';

/**
 * 推理力度选项（UI 展示用）：低 = 快速响应，高 = 默认均衡，最大 = 最深度思考。
 * 注意：只有用户显式选择后才随请求发送 reasoning_effort 参数；
 * 未选择（null）时保持模型自身默认（避免不支持该参数的模型报错）。
 */
export const AI_EFFORT_OPTIONS: ReadonlyArray<{ value: AIReasoningEffort; label: string; desc: string }> = [
  { value: 'low', label: '低', desc: '快速响应，思考最少；仅支持推理力度的模型生效' },
  { value: 'high', label: '高', desc: '模型默认（DeepSeek V4 默认档）：均衡的思考与速度' },
  { value: 'max', label: '最大', desc: '最深度思考，速度最慢但质量最高；仅支持推理力度的模型生效' },
];

/** 展示用当前档位：null（未显式设置）时视为默认档 */
export function effortDisplayValue(effort: AIReasoningEffort | null): AIReasoningEffort {
  return effort ?? AI_DEFAULT_EFFORT;
}
